<!--
  ClassStatusChartCard — Pineapple 톤
  · 외부 카드 크롬 제거: Pineapple ACard 안에서 호출되므로 차트와 범례만 렌더
  · Pineapple 컬러 (노란/검정/연한 검정) 로 Chart.js 시각화
-->
<template>
  <div class="p-pie">
    <div class="p-pie__chart">
      <canvas :id="chartId" />
    </div>
    <div class="p-pie__legend">
      <div v-for="(label, i) in chart.labels" :key="i" class="p-pie__legend-row">
        <span class="p-pie__legend-dot" :style="{ background: palette[i] }" />
        <span class="p-pie__legend-label">{{ label }}</span>
        <span class="p-pie__legend-value">{{ chart.datasets.data[i] }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import Chart from 'chart.js/auto';

export default {
  name: 'ClassStatusChartCard',
  props: {
    chartData: {
      type: Object,
      required: true,
      default: () => ({
        labels: ['진행중', '예정', '완료', '중단'],
        datasets: { label: '클래스 상태', data: [0, 0, 0, 0] },
      }),
    },
  },
  data() {
    return {
      chartId: `pine-pie-${Math.random().toString(36).slice(2, 9)}`,
      // Pineapple: point (yellow), ink (dark), point-deep (gold), ink-soft (gray)
      palette: ['#FFC93C', '#1F1B14', '#C98A0A', '#9C9486'],
      instance: null,
    };
  },
  computed: {
    chart() {
      return {
        labels: this.chartData.labels,
        datasets: this.chartData.datasets,
      };
    },
  },
  watch: {
    chartData: {
      deep: true,
      handler() { this.renderChart(); },
    },
  },
  mounted() { this.renderChart(); },
  beforeUnmount() {
    if (this.instance) this.instance.destroy();
  },
  methods: {
    renderChart() {
      const el = document.getElementById(this.chartId);
      if (!el) return;
      const existing = Chart.getChart(this.chartId);
      if (existing) existing.destroy();

      this.instance = new Chart(el.getContext('2d'), {
        type: 'doughnut',
        data: {
          labels: this.chart.labels,
          datasets: [{
            label: this.chart.datasets.label,
            data: this.chart.datasets.data,
            backgroundColor: this.palette,
            borderColor: '#FFFFFF',
            borderWidth: 3,
          }],
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          cutout: '62%',
          plugins: {
            legend: { display: false },
            tooltip: {
              backgroundColor: '#1F1B14',
              titleColor: '#FFC93C',
              bodyColor: '#F6EFDB',
              borderColor: '#1F1B14',
              padding: 10,
              cornerRadius: 8,
            },
          },
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/_pineapple.scss';

.p-pie {
  display: grid;
  grid-template-columns: 180px 1fr;
  gap: 24px;
  align-items: center;

  @media (max-width: 600px) {
    grid-template-columns: 1fr;
  }

  &__chart {
    height: 180px;
    position: relative;
  }

  &__legend {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }
  &__legend-row {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 6px 0;
    border-bottom: 1px solid $p-line-soft;
    font-family: $p-font-body;

    &:last-child { border-bottom: 0; }
  }
  &__legend-dot {
    width: 10px;
    height: 10px;
    border-radius: 3px;
    flex-shrink: 0;
  }
  &__legend-label {
    flex: 1;
    font-size: 12px;
    color: $p-ink2;
    font-weight: 600;
  }
  &__legend-value {
    font-family: $p-font-mono;
    font-size: 12px;
    font-weight: 800;
    color: $p-ink;
  }
}
</style>
